module.exports = __webpack_public_path__ + "img/7_206.d636797a.png";